import { getRouteApi } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@ui/skeleton.tsx';
import { useUser } from '@r/api/auth.tsx';
import { getActiveWorkspaceUniversal } from '@r/helpers/api.ts';
import { useApiAdminsalesHierarchiesIdGet } from '@r/api/generated/client.ts';
import { useOrvalQueryErrorToast } from '@r/hooks/use-orval-error-toast.ts';
import { SalesHierarchyCanvas } from '@admin/components/hierarchy/sales-hierarchy-canvas.tsx';
import { useHierarchyCanvasStore } from '@admin/components/hierarchy/hierarchy-canvas-store.ts';

const routeApi = getRouteApi('/auth-layout/settings/hierarchy/$id');

export const HierarchyDetail = () => {
  const { t } = useTranslation();
  const { id } = routeApi.useParams();
  const hierarchyId = Number(id);
  const user = useUser();
  const activeWorkspace = getActiveWorkspaceUniversal(user.data?.visibleWorkspaces ?? []);
  const canManage = Boolean(
    activeWorkspace?.roles?.includes('ROLE_ADMIN') ||
      activeWorkspace?.roles?.includes('ROLE_FIDDY_ADMIN')
  );

  const hierarchyQuery = useApiAdminsalesHierarchiesIdGet(id);
  useOrvalQueryErrorToast(hierarchyQuery, t('toast.error.label'));

  // Publié par le canvas (frère dans l'arbre de composants) dans hierarchy-canvas-store.ts.
  const placedCount = useHierarchyCanvasStore((state) => state.placedUniqueCodes.size);

  if (hierarchyQuery.isLoading) {
    return <Skeleton className="w-full h-12" />;
  }

  return (
    <div className="relative h-full w-full">
      <SalesHierarchyCanvas hierarchyId={hierarchyId} canManage={canManage} />

      <div className="absolute left-5 top-14 z-10">
        <h1 className="text-4xl font-bold">{hierarchyQuery.data?.name}</h1>
        <p className="text-sm text-muted-foreground">
          {t('admin.hierarchy.detail.placed.count', { count: placedCount })}
        </p>
      </div>
    </div>
  );
};
